(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["special-offer-codes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('special-offer-copy-button')) {
    class SpecialOfferCopyButton extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-copy-label]');
        this.status = this.querySelector('[data-copy-status]');
        this.defaultLabel = this.label ? this.label.textContent : '';
        this.button?.addEventListener('click', () => this.copy());
      }

      disconnectedCallback() {
        window.clearTimeout(this.resetTimer);
      }

      async copy() {
        const text = this.dataset.text || '';

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
          } else {
            this.copyWithFallback(text);
          }

          this.showCopiedState();
        } catch (error) {
          this.copyWithFallback(text);
          this.showCopiedState();
        }
      }

      copyWithFallback(text) {
        const input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
        this.button?.focus({ preventScroll: true });
      }

      showCopiedState() {
        const copiedLabel = this.dataset.copiedLabel || this.defaultLabel;
        window.clearTimeout(this.resetTimer);
        this.dataset.state = 'copied';

        if (this.label) this.label.textContent = copiedLabel;
        if (this.status) this.status.textContent = copiedLabel;

        this.resetTimer = window.setTimeout(() => {
          delete this.dataset.state;
          if (this.label) this.label.textContent = this.defaultLabel;
          if (this.status) this.status.textContent = '';
        }, 2200);
      }
    }

    customElements.define('special-offer-copy-button', SpecialOfferCopyButton);
  }

  } catch(e) { console.error(e); }
})();
})();
